import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { delete_notification } from "../../redux/features/toastSlice";

const Toast = ({ position='top-right', autoDeleteTimeout='3000' }) => {
  const toastState = useSelector(state => state.toastState)
  const dispatch = useDispatch();
  

  const generateIcon = (type) => {
    switch (type) {
      case "INFO":
        return <i className="fa-solid fa-circle-exclamation"></i>;
      case "WARNING":
        return <i className="fa-solid fa-triangle-exclamation"></i>;
      case "DANGER":
        return <i className="fa-solid fa-circle-exclamation"></i>;
      case "SUCCESS":
        return <i className="fa-solid fa-check"></i>;
      default:
        return;
    }
  };

  const generateBackgroundColor = (type) => {
    switch (type) {
      case "INFO":
        return "#5bc0de";
      case "WARNING":
        return "#f0ad4e";
      case "DANGER":
        return "#d9534f";
      case "SUCCESS":
        return "#1e90ff";
      default:
        return;
    }
  };

  return (
    <div className={`notification-container ${position}`}>
      {toastState.map((notification, i) => {
        if (autoDeleteTimeout) {
          setTimeout(() => {
            dispatch(delete_notification(notification.id));
          }, autoDeleteTimeout);
        }
        return (
          <div
            style={{
              backgroundColor: generateBackgroundColor(notification.type),
            }}
            key={notification.id}
            className={`notification my-toast ${position}`}
          >
            
            <i className="fa-solid fa-rectangle-xmark close-button"  onClick={() =>
                dispatch(delete_notification(notification.id))
              }></i>
            
            
 
 
            <div className="notification-image">
              {generateIcon(notification.type)}
            </div>
            <div>
              <p className="notification-title">{notification.title}</p>
              <p className="notification-message">{notification.message}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Toast;